import { render, staticRenderFns } from "./PrizePicture.vue?vue&type=template&id=65337bc0&scoped=true&"
import script from "./PrizePicture.vue?vue&type=script&lang=js&"
export * from "./PrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizePicture.vue?vue&type=style&index=0&id=65337bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65337bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65337bc0')) {
      api.createRecord('65337bc0', component.options)
    } else {
      api.reload('65337bc0', component.options)
    }
    module.hot.accept("./PrizePicture.vue?vue&type=template&id=65337bc0&scoped=true&", function () {
      api.rerender('65337bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/PrizePicture.vue"
export default component.exports